<div
  class="add-credentials-component"
>
  <div class="accordion" id="credentialOptions">
    <ng-container *ngFor="let cred of credentials; index as i">
      <div
        *ngIf="cred.key === 'credentials-' + getAppConstant('AC_AM_WEB_AUTHN_PUBLIC_KEY')"
        class="{{this.hasPassword() ? 'card' : ''}}"
      >
        <div *ngIf="this.hasPassword()" class="card-header"
             role="button'"
             (click)="toggleCollapse('passkey')">
          <h3 class="mb-0 d-flex" id="passkeySetupHeading">
            <div *ngIf="i === 0">
              {{'add-credentials.passkey.primary-title' | translate}}
            </div>
            <div *ngIf="i !== 0">
              {{'add-credentials.passkey.secondary-title' | translate}}
            </div>
            <div class="ml-auto d-flex">
              <div
                *ngIf="!isPasskeyCollapsed && !!this.passkeyCreds"
                class="icon text-success"
              >
                <span class="fa fa-fw fa-check"></span>
              </div>
              <div *ngIf="isPasskeyCollapsed && !!this.passkeyCreds"
                   class="icon text-muted"
                   [ngbTooltip]="'add-credentials.click-to-select-tip'|translate"
                   container="body"
              >
                <span class="fa fa-fw fa-ban"></span>
              </div>
            </div>
          </h3>
        </div>
        <div #passkeyCollapse="ngbCollapse" [(ngbCollapse)]="isPasskeyCollapsed"
             id="passkeySetup"
             aria-labelledby="passkeySetupHeading">
          <div class="{{this.hasPassword() ? 'card-body' : ''}}">
            <h4 *ngIf="!!passkeyActive" class="text-center">
              {{'add-credentials.waiting-for-passkey' | translate}}
            </h4>
            <div *ngIf="!!passkeyActive" class="loader-wrapper position-relative d-block mb-2">
              <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            </div>
            <button
              *ngIf="!passkeyActive && this.passkeyCreds !== undefined"
              class="btn btn-block btn-lg btn-success"
              type="button"
              [disabled]="true"
            >
              {{'add-credentials.passkey.registered-button.label' | translate}}
            </button>
            <button
              *ngIf="!passkeyActive && this.passkeyCreds === undefined"
              class="btn btn-block btn-lg btn-auto"
              type="button"
              (click)="startPasskeyRegister()"
            >
              {{'add-credentials.passkey.register-button.label' | translate}}
            </button>

            <button
              *ngIf="!passkeyActive"
              (click)="togglePasskeyInfoCollapse()"
              class="btn btn-block btn-sm btn-link"
              type="button"
              id="passkeyInfoButton"
            >
              {{'add-credentials.passkey.what-is-passkey-button.label' | translate}}
            </button>

            <div #passkeyInfoCollapse="ngbCollapse" [(ngbCollapse)]="isPasskeyInfoCollapsed"
                 id="passkeyInfoCollapse"
                 aria-labelledby="passkeyInfoButton"
            >
              <h5>{{'add-credentials.passkey.info-tip.title1'|translate}}</h5>
              <p>{{'add-credentials.passkey.info-tip.copy1'|translate}}</p>
              <h6>{{'add-credentials.passkey.info-tip.title2'|translate}}</h6>
              <p>{{'add-credentials.passkey.info-tip.copy2'|translate}}</p>
              <h6>{{'add-credentials.passkey.info-tip.title3'|translate}}</h6>
              <p>{{'add-credentials.passkey.info-tip.copy3'|translate}}</p>
              <h6>{{'add-credentials.passkey.info-tip.title4'|translate}}</h6>
              <p class="mb-0">{{'add-credentials.passkey.info-tip.copy4'|translate}}</p>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="cred.key === 'credentials-' + getAppConstant('AC_AM_PASSWORD')"
        class="{{this.hasPasskey() ? 'card' : ''}}"
      >
        <div *ngIf="this.hasPasskey()" class="card-header"
             (click)="toggleCollapse('password')"
             role="button"
        >
          <h3 class="mb-0 d-flex" id="passwordSetupHeading">
            <div *ngIf="i === 0">
              {{'add-credentials.password.primary-title' | translate}}
            </div>
            <div *ngIf="i !== 0">
              {{'add-credentials.password.secondary-title' | translate}}
            </div>
            <div class="ml-auto d-flex">
              <div
                *ngIf="!isPasswordCollapsed && this.form.valid"
                class="icon text-success"
              >
                <span class="fa fa-fw fa-check"></span>
              </div>
              <div
                *ngIf="isPasswordCollapsed && !!this.form.get('password').value"
                class="icon text-muted"
                [ngbTooltip]="'add-credentials.click-to-select-tip'|translate"
                container="body"
              >
                <span class="fa fa-fw fa-ban"></span>
              </div>
            </div>
          </h3>
        </div>
        <div #passwordCollapse="ngbCollapse" [(ngbCollapse)]="isPasswordCollapsed"
        id="passwordSetup" aria-labelledby="passwordSetupHeading">
          <div class="{{this.hasPasskey() ? 'card-body' : ''}}">
            <form
              [formGroup]="form"
            ><div
              app-form-input
              field="password"
              type="password"
              autocomplete="new-password"
              label="{{'add-credentials.password.label' | translate}}"
              [isInvalid]="isFieldInvalid('password')"
              [isValid]="isFieldValid('password')"
            >
              <div
                app-form-input-feedback
                [type]="!isFieldInvalid('password') ? 'info' : 'invalid'"
              >
                <ng-container *ngIf="!isFieldInvalid('password')">{{'add-credentials.password.info' | translate}}</ng-container>
                <ng-container *ngIf="isFieldInvalid('password')">{{'add-credentials.password.error-message.required-or-invalid' | translate}}</ng-container>
              </div>
            </div>

              <div
                app-form-input
                field="confirmPassword"
                type="password"
                autocomplete="new-password"
                label="{{'add-credentials.confirm-password.label' | translate}}"
                [isInvalid]="isFieldInvalid('confirmPassword')"
                [isValid]="isFieldValid('confirmPassword')"
              >
                <div
                  app-form-input-feedback
                  type="invalid"
                  *ngIf="isFieldInvalid('confirmPassword')"
                >{{'add-credentials.confirm-password.error-message.required-or-invalid' | translate}}</div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ng-container>
  </div>


</div>
